<mat-card appearance="outlined" class="mat-ctrlkey-stone px-2">
  <mat-card-content>
    <div class="row">
      <!-- Project info -->
      <div class="col-12 col-lg me-lg-auto">
        <div class="row my-0">
          <div class="col-auto gx-0 mb-auto" [matTooltip]="allLocked ? 'All projects locked for editing' : lockCount + ' of ' + projectInfo.length + ' locked'">
            <mat-icon class="align-middle" aria-hidden="false" aria-label="Project lock state" [fontIcon]="allLocked ? 'lock' : 'lock_open'"></mat-icon>
          </div>
          <div class="col gx-0 ps-0">
            <h4 class="align-middle">Portfolio: {{ portfolioTitle }}</h4>
          </div>
        </div>
        <div class="row ms-4 gx-0">
          <div class="col-auto pe-2">
            <div class="badge rounded-pill bg-light text-dark d-inline-flex align-items-center pill-info" matTooltip="Earliest Scheduled Start Date">
              <mat-icon fontIcon="first_page" class="pill-icon me-1"></mat-icon>
              {{ earliestStart | datetimeToDate }}
            </div>
          </div>
          <div class="col-auto pe-2">
            <div class="badge rounded-pill bg-light text-dark d-inline-flex align-items-center pill-info" matTooltip="Earliest Current Progress Date">
              <mat-icon fontIcon="calendar_today" class="pill-icon me-1"></mat-icon>
              {{ earliestDataDate | datetimeToDate }}
            </div>
          </div>
          <div class="col-auto pe-2">
            <div class="badge rounded-pill bg-light text-dark d-inline-flex align-items-center pill-info" matTooltip="Latest Scheduled End Date">
              <mat-icon fontIcon="last_page" class="pill-icon me-1"></mat-icon>
              {{ latestEnd | datetimeToDate }}
            </div>
          </div>
          <div class="col-auto pe-2">
            <div class="badge rounded-pill bg-light text-dark d-inline-flex align-items-center pill-info" matTooltip="Total Combined Activities">
              <mat-icon fontIcon="bar_chart" class="pill-icon rotate-90 me-1"></mat-icon>{{ totalTasks }}
            </div>
          </div>
        </div>
      </div>

      <!-- Project controls -->
      @if (accessLevel >= PERMISSION_LEVEL.EDIT) {
        <div class="col-12 col-lg-6 text-center">
          <div class="row justify-content-center justify-content-lg-end pt-2 pt-lg-0 pb-1">
            @if (isSiteAdmin) {
              @if (canLock && !isArchived) {
                <div class="col-auto pe-4">
                  <div class="row pb-1" [matTooltip]="allLocked ? 'Unlock portfolio' : 'Lock portfolio'">
                    <a matFab extended class="narrow-button" routerLink="." (click)="toggleProjectLock()">
                      {{ allLocked ? 'Unlock' : 'Lock' }} Portfolio
                      <mat-icon>{{ allLocked ? 'lock_open' : 'lock' }}</mat-icon>
                    </a>
                  </div>
                </div>
              }
              <div class="col-auto pe-4">
                <div class="row pb-1" matTooltip="Upload project file">
                  <input [formControl]="projectUploadControl" type="file" multiple accept=".xer,.mpp" class="d-none" (change)="projectFileUpload($event)" #fileUpload>
                  <a matFab extended class="narrow-button" routerLink="." (click)="fileUpload.click()">
                    Update Project
                    <mat-icon>upload</mat-icon>
                  </a>
                </div>
              </div>
            }
            <!-- Exports -->
            @if (accessLevel >= PERMISSION_LEVEL.EXPT) {
              <div class="col-auto pe-4">
                <div class="row pb-1">
                  <a matFab extended class="narrow-button" routerLink="." [matMenuTriggerFor]="menu">
                    Export
                    <mat-icon>download</mat-icon>
                  </a>
                  <!-- Menu options -->
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="exportWBS()">
                      <mat-icon>list</mat-icon>
                      <span>Filtered WBS & Activities</span>
                    </button>
                    @if (extAssignment) {
                      <button mat-menu-item (click)="exportAssignedWork()">
                        <mat-icon>access_time</mat-icon>
                        <span>Assigned Work Report</span>
                      </button>
                      <button mat-menu-item (click)="exportBudgetHours()">
                        <mat-icon>hourglass_bottom</mat-icon>
                        <span>Activity Assigned Hours</span>
                      </button>
                      <button mat-menu-item (click)="exportEarnedValue()">
                        <mat-icon>attach_money</mat-icon>
                        <span>Earned Value</span>
                      </button>
                      <button mat-menu-item (click)="exportNoPercentageUpdate()">
                        <mat-icon>question_mark</mat-icon>
                        <span>Assigned Work no Percentage Update</span>
                      </button>
                    }
                    @if (extChanges) {
                      <button mat-menu-item (click)="exportChangedPercentComplete()">
                        <mat-icon>percent</mat-icon>
                        <span>Updated percentage complete</span>
                      </button>
                    }
                    @if (isSiteAdmin && extAssignment) {
                      <button mat-menu-item (click)="exportMissingTasks()">
                        <mat-icon>no_sim</mat-icon>
                        <span>Work Assignments Missing Tasks</span>
                      </button>
                    }
                    <button mat-menu-item (click)="exportComments()">
                      <mat-icon>comment</mat-icon>
                      <span>Comments</span>
                    </button>
                    @if (isGlobalAdmin) {
                      <button mat-menu-item (click)="exportUserAccess()">
                        <mat-icon>access_alarm</mat-icon>
                        <span>Latest User Access</span>
                      </button>
                    }
                  </mat-menu>
                </div>
              </div>
            }
          </div>
        </div>
      }

    </div>
  </mat-card-content>
</mat-card>